import styled from '@emotion/styled'
import ManagePageLayout from '@/components/manage/Layout'
import ManageVideosHeader from '@/components/manage/videos/Header'
import { Flex } from '@collable/ui'
import ManageVideoList from '@/components/manage/videos/VideoList'

const VideosPage = () => {
  return (
    <ManagePageLayout pageType="video">
      <Container direction="column" gap={48}>
        <ManageVideosHeader />
        <ManageVideoList />
      </Container>
    </ManagePageLayout>
  )
}

export default VideosPage

const Container = styled(Flex)`
  height: 100%;
  padding: 48px 48px 0 48px;
  width: 100%;
  overflow-y: scroll;
`
